import { EmployeeProfileQuery, EmployeeProfilesQuery } from "generated/graphql";
import { UserTableSort } from "./Sort";

/* STATUS */

export enum UserStatus {
  ACTIVE = "active",
  CANCELED = "canceled",
  PENDING = "pending",
  REVIEW = "review",
}

export const activeUserStatuses = [
  UserStatus.ACTIVE,
  UserStatus.PENDING,
  UserStatus.REVIEW,
];

/* EMPLOYMENT STATUS */

export enum EmploymentStatus {
  EMPLOYED = "employed",
  TERMINATED = "terminated",
}

/* External ID KIND */

export enum UserExternalIDKind {
  alternative_id = "alternative_id",
  external_id = "external_id",
}

/* BENEFIT */

export enum Benefit {
  WISELY = "wisely",
}

export type GetEmployeeProfilesQueryFiltersProps = {
  employmentStatusFilters: EmploymentStatus[];
  userStatusFilters: UserStatus[];
  payGroupFilters: string[];
  locationFilters: string[];
  benefitFilters: Benefit[];
};

export interface GetEmployeeProfilesQueryProps
  extends GetEmployeeProfilesQueryFiltersProps {
  page: number;
  search: string;
  sort: UserTableSort;
}

export const startingPage = 1;

export const initialQueryProps: GetEmployeeProfilesQueryProps = {
  page: startingPage,
  search: "",
  employmentStatusFilters: [EmploymentStatus.EMPLOYED],
  userStatusFilters: [],
  locationFilters: [],
  payGroupFilters: [],
  benefitFilters: [],
  sort: ["lastName", "asc"],
};

export type DPEmployeeProfiles = EmployeeProfilesQuery["employeeProfiles"];
export type DPEmployeeProfileItem =  DPEmployeeProfiles["items"][0];

export const initialEmployeeProfilesResponse: DPEmployeeProfiles = {
  items: [],
  totalCount: 0,
};

export type DPEmployeeProfile = EmployeeProfileQuery["employeeProfile"];

export type DPProviderAccount = DPEmployeeProfile["providerAccounts"]["items"][0];

export type DPPartialPayPeriod = NonNullable<DPProviderAccount["payPeriods"]>["items"][0];

export interface PayGroup {
  id: string;
  providerAccountId: string;
  payPeriods: DPPartialPayPeriod[];
}
